export default {
    init() {
        $(window).resize(function () {
            var bodyheight = $('.embed-responsive-item iframe').height();
            $('.chat-player iframe').height(bodyheight);
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-live.js